import React, { useContext, useState, useEffect } from 'react';
import { GlobalContext } from '../lib/GlobalVar';
import { SalvaConfigPessoal, ConsultaPanorama, SalvaPanorama, MontaPanorama, ConsultaInternas } from '../lib/api';
import { falar } from '../lib/voz';
import { encrypt } from '../lib/aes';
import Swal from 'sweetalert2';
import { silenciar } from '../lib/voz';
import Icon from './Icon';
import sfx from '../lib/sfx';
import TemplateEditor from './TemplateEditor';

export default function Configuracoes() {
    const { user } = useContext(GlobalContext);
    const [atual, setAtual] = useState('');
    const [nova, setNova] = useState('');
    const [confirma, setConfirma] = useState('');

    // iter9: toggle do assistente de voz (persiste em localStorage)
    const [vozAtiva, setVozAtiva] = useState(() => {
        // desligado por padrão: só fica ligado para quem ativou (o mesmo critério do AssistenteVoz)
        try { return localStorage.getItem('centralbabita.voz.ativo') === 'true'; } catch { return false; }
    });
    function toggleVoz(v) {
        setVozAtiva(v);
        try { localStorage.setItem('centralbabita.voz.ativo', v ? 'true' : 'false');
        if (!v) try { silenciar(); } catch (_) {} } catch (_) {}
        try { window.dispatchEvent(new Event('centralbabita:voz-toggle')); } catch (_) {}
    }
    // iter9.2: avisos por voz - TTS exclusivamente via Piper Cadu (backend).
    const [vozAvisos, setVozAvisos] = useState(() => {
        try { return localStorage.getItem('centralbabita.voz.avisos') !== 'false'; } catch { return false; }
    });
    const [testandoVoz, setTestandoVoz] = useState(false);
    function toggleAvisos(v) {
        setVozAvisos(v);
        try { localStorage.setItem('centralbabita.voz.avisos', v ? 'true' : 'false');
        if (!v) try { silenciar(); } catch (_) {} } catch (_) {}
    }
    // iter9.4: resumo falado ao mudar de tela
    const [vozResumo, setVozResumo] = useState(() => {
        try { return localStorage.getItem('centralbabita.voz.resumo') !== 'false'; } catch { return false; }
    });
    function toggleResumo(v) {
        setVozResumo(v);
        try { localStorage.setItem('centralbabita.voz.resumo', v ? 'true' : 'false');
        if (!v) try { silenciar(); } catch (_) {} } catch (_) {}
    }
    const [sfxOn, setSfxOn] = useState(() => { try { return localStorage.getItem('centralbabita.sfx.ativo') !== 'false'; } catch { return true; } });
    function toggleSfx(v) { setSfxOn(v); sfx.toggle(v); }
    async function testarVoz() {
        // iter9.3: usa singleton de voz - se ja houver fala em andamento, entra na fila.
        setTestandoVoz(true);
        try { await falar('Olá, eu sou o Cadu, a voz da Central Babita. Sistema operacional, tudo certo.'); }
        finally { setTestandoVoz(false); }
    }

    // panorama de boas-vindas (Cadu fala ao abrir)
    const [panorama, setPanorama] = useState({ template: '', ativo: true });
    useEffect(() => { ConsultaPanorama({}).then(r => { if (r && !r.Error) setPanorama({ template: r.template || '', ativo: r.ativo !== false }); }); }, []);
    async function salvarPanorama() {
        const r = await SalvaPanorama({ solicitante: user?.email, template: panorama.template, ativo: panorama.ativo });
        if (r && r.Error) return Swal.fire({ icon: 'error', title: 'Erro', text: r.Error });
        Swal.fire({ icon: 'success', title: 'Panorama salvo', timer: 1100, showConfirmButton: false });
    }
    async function testarPanorama() {
        const r = await MontaPanorama({ user_id: user?.id, nome: user?.nome });
        if (r && r.texto) falar(r.texto);
        else Swal.fire({ icon: 'info', title: 'Panorama', text: (r && r.Error) || 'Panorama vazio ou desativado.' });
    }

    const tem10 = nova.length >= 10;
    const temMai = /[A-Z]/.test(nova);
    const temNum = /[0-9]/.test(nova);
    const confere = nova.length > 0 && nova === confirma;
    const senhaOk = tem10 && temMai && temNum && confere && atual.length > 0;

    async function salvarSenha() {
        if (!senhaOk) return Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Preencha senha atual e verifique os critérios da nova.' });
        const resp = await SalvaConfigPessoal({
            solicitante: user?.email,
            user_id: user?.id,
            SENHA_ATUAL: encrypt(atual),
            NOVA_SENHA: encrypt(nova),
        });
        if (resp.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: resp.Error });
        setAtual(''); setNova(''); setConfirma('');
        Swal.fire({ icon: 'success', title: 'Senha atualizada', timer: 1100, showConfirmButton: false });
    }

    return (
        <div className="page">
            <div className="page-head">
                <div>
                    <div className="eyebrow"><span className="num">07</span> Sistema · Sua conta</div>
                    <h1 className="page-title">Configurações</h1>
                    <p className="page-sub">Sua senha de acesso à Central e o aviso sobre o acesso aos arquivos.</p>
                </div>
            </div>

            <div className="account-head">
                <div>
                    <h2 className="section-title">Conta</h2>
                    <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>{user?.email} · {user?.setor} · {user?.cargo}</div>
                </div>
                <div className="eyebrow">Ajustes pessoais</div>
            </div>

            <div className="settings-grid-roomy">

                {user?.senha_do_erp ? (
                <section className="cfg-card">
                    <header className="cfg-card-head">
                        <div className="cfg-card-eyebrow">
                            <Icon name="lock" size={13}/>
                            <span>Acesso à Central</span>
                        </div>
                        <h3 className="cfg-card-title">Senha de login</h3>
                        <p className="cfg-card-desc">
                            Sua senha de acesso é a do ERP: a Central não a guarda nem a troca. Para trocar, peça a troca no ERP.
                        </p>
                    </header>
                </section>
                ) : (
                <section className="cfg-card">
                    <header className="cfg-card-head">
                        <div className="cfg-card-eyebrow">
                            <Icon name="lock" size={13}/>
                            <span>Acesso à Central</span>
                        </div>
                        <h3 className="cfg-card-title">Senha de login</h3>
                        <p className="cfg-card-desc">
                            Sua senha pessoal para entrar no painel. Gravada em <span className="mono">CentralBabita-secure/logins.json</span> (AES + MD5).
                        </p>
                    </header>

                    <div className="cfg-card-body">
                        <div className="field">
                            <label>Senha atual</label>
                            <input className="input" type="password" value={atual} onChange={e => setAtual(e.target.value)} autoComplete="current-password"/>
                        </div>

                        <div className="cfg-row-2">
                            <div className="field">
                                <label>Nova senha</label>
                                <input className="input" type="password" value={nova} onChange={e => setNova(e.target.value)} placeholder="Mínimo 10 caracteres" autoComplete="new-password"/>
                            </div>
                            <div className="field">
                                <label>Confirmar nova senha</label>
                                <input className="input" type="password" value={confirma} onChange={e => setConfirma(e.target.value)} autoComplete="new-password"/>
                            </div>
                        </div>

                        <div className="cfg-criteria">
                            <span className="cfg-criteria-label">Critérios</span>
                            <div className="chips-row" style={{ marginTop: 0 }}>
                                <span className={`chip ${tem10 ? 'on' : ''}`}>Mínimo 10</span>
                                <span className={`chip ${temMai ? 'on' : ''}`}>Maiúscula</span>
                                <span className={`chip ${temNum ? 'on' : ''}`}>Número</span>
                                <span className={`chip ${confere ? 'on' : ''}`}>Confere</span>
                            </div>
                        </div>
                    </div>

                    <footer className="cfg-card-foot">
                        <button className="btn ghost sm" onClick={() => { setAtual(''); setNova(''); setConfirma(''); }}>Cancelar</button>
                        <button className="btn sm" onClick={salvarSenha} disabled={!senhaOk}>Atualizar senha</button>
                    </footer>
                </section>
                )}

                <section className="cfg-card">
                    <header className="cfg-card-head">
                        <div className="cfg-card-eyebrow">
                            <Icon name="folder" size={13}/>
                            <span>Arquivos · Samba</span>
                        </div>
                        <h3 className="cfg-card-title">Acesso aos arquivos</h3>
                        <p className="cfg-card-desc">
                            O usuário Samba de cada pessoa agora é escolhido pela <b>TI</b> (tela Acesso a Arquivos). Você não precisa mais cadastrar nem guardar senha aqui:
                            se estiver sem acesso, peça à TI para associar o seu usuário.
                        </p>
                    </header>
                </section>

                <section className="cfg-card">
                    <header className="cfg-card-head">
                        <div className="cfg-card-eyebrow">
                            <Icon name="sparkle" size={13}/>
                            <span>Acessibilidade · Voz</span>
                        </div>
                        <h3 className="cfg-card-title">Assistente de voz</h3>
                        <p className="cfg-card-desc">
                            Quando ativado, um botão flutuante aparece no canto inferior direito. Clique e fale comandos como
                            <span className="mono"> "dashboard"</span>, <span className="mono">"alertas"</span>, <span className="mono">"monitor"</span> ou
                            <span className="mono"> "buscar &lt;termo&gt;"</span>. Reconhecimento feito pelo navegador (Chrome/Edge), sem enviar áudio para servidor.
                        </p>
                    </header>

                    <div className="cfg-card-body">
                        <label style={{ display:'flex', alignItems:'center', gap:10, fontSize:13, cursor:'pointer' }}>
                            <input type="checkbox" checked={vozAtiva} onChange={e => toggleVoz(e.target.checked)}/>
                            <span><b>Ativar assistente de voz</b> &mdash; aplica imediatamente.</span>
                        </label>

                        <div className="cfg-note" style={{ marginTop:14 }}>
                            <span className={`dot ${vozAtiva ? 'ok' : ''}`}/>
                            <span className="muted" style={{ fontSize: 11.5 }}>
                                {vozAtiva
                                    ? 'Ativado. O botão de microfone está visível em todas as telas.'
                                    : 'Desativado. Nenhum botão aparece e o microfone nunca é acionado.'}
                            </span>
                        </div>

                        {/* iter9.1: avisos automaticos */}
                        <div style={{ borderTop:'1px dashed var(--line)', marginTop:16, paddingTop:14 }}>
                            <label style={{ display:'flex', alignItems:'center', gap:10, fontSize:13, cursor: vozAtiva?'pointer':'not-allowed', opacity: vozAtiva?1:0.55 }}>
                                <input type="checkbox" checked={vozAvisos} disabled={!vozAtiva} onChange={e => toggleAvisos(e.target.checked)}/>
                                <span><b>Falar avisos automáticos</b> &mdash; rotinas concluídas/com falha e novos alertas. Polling a cada 30s.</span>
                            </label>
                        </div>

                        {/* iter9.4: resumo ao navegar */}
                        <div style={{ borderTop:'1px dashed var(--line)', marginTop:14, paddingTop:14 }}>
                            <label style={{ display:'flex', alignItems:'center', gap:10, fontSize:13, cursor: vozAtiva?'pointer':'not-allowed', opacity: vozAtiva?1:0.55 }}>
                                <input type="checkbox" checked={vozResumo} disabled={!vozAtiva} onChange={e => toggleResumo(e.target.checked)}/>
                                <span><b>Resumo falado ao mudar de tela</b> &mdash; ao navegar para Alertas/Monitor/Bancos/Logins o Cadu fala um resumo com números.</span>
                            </label>
                        </div>

                        {/* iter9.2: voz TTS via Piper Cadu (backend IABabita) */}
                        <div style={{ borderTop:'1px dashed var(--line)', marginTop:14, paddingTop:14 }}>
                            <div className="field">
                                <label>Voz do assistente</label>
                                <div style={{ display:'flex', gap:10, alignItems:'center' }}>
                                    <span className="chip on mono" style={{ fontSize:11 }}>CADU · pt-BR</span>
                                    <span className="muted" style={{ fontSize:11.5 }}>
                                        Gerada pelo Piper TTS no servidor IA Babita (192.168.0.204). Modelo único, sem dependência de voz do navegador.
                                    </span>
                                </div>
                                <div style={{ marginTop:10 }}>
                                    <button className="btn ghost sm" onClick={testarVoz} disabled={!vozAtiva || testandoVoz}>
                                        {testandoVoz ? 'Falando…' : 'Testar voz Cadu'}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* iter15: sons da interface */}
                        <div style={{ borderTop:'1px dashed var(--line)', marginTop:14, paddingTop:14 }}>
                            <label style={{ display:'flex', alignItems:'center', gap:10, fontSize:13, cursor:'pointer' }}>
                                <input type="checkbox" checked={sfxOn} onChange={e => toggleSfx(e.target.checked)}/>
                                <span><b>Sons da interface</b> &mdash; bipes curtos de clique, confirmação, aviso e erro nos botões e menus.</span>
                            </label>
                        </div>

                        {/* iter13: panorama de boas-vindas falado ao abrir o sistema */}
                        <div style={{ borderTop:'1px dashed var(--line)', marginTop:14, paddingTop:14 }}>
                            <div className="field">
                                <label>Panorama de boas-vindas (falado ao abrir o sistema)</label>
                                <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, margin:'6px 0', cursor:'pointer' }}>
                                    <input type="checkbox" checked={panorama.ativo} onChange={e=>setPanorama({ ...panorama, ativo:e.target.checked })}/>
                                    <span>Falar o panorama quando eu entrar no sistema</span>
                                </label>
                                <TemplateEditor
                                    value={panorama.template}
                                    onChange={t => setPanorama({ ...panorama, template: t })}
                                    rows={3}
                                    placeholder="{saudacao}, {usuario}. Você tem {alertas} alerta(s)..."
                                    vars={[
                                        { token: '{saudacao}', label: 'Bom dia/tarde/noite', opcoes: ['Bom dia', 'Boa tarde', 'Boa noite'] },
                                        { token: '{usuario}', label: '1º nome' },
                                        { token: '{alertas}', label: 'qtd pendentes' },
                                        { token: '{rotinas}', label: 'qtd ativas' },
                                        { token: '{rotinas_falhas}', label: 'falharam' },
                                        { token: '{data}', label: 'data por extenso' },
                                        { token: '{hora}', label: 'hora atual' },
                                    ]}
                                    kpiTelas={async () => {
                                        const r = await ConsultaInternas({ solicitante: user?.email });
                                        return (Array.isArray(r) ? r : []).filter(t => t.slug && (t.colunas || []).length).map(t => ({
                                            slug: t.slug, titulo: t.titulo || t.slug,
                                            colunas: (t.colunas || []).map(c => ({ valor: String(c.nome != null ? c.nome : c.chave), label: c.label || c.nome || c.chave })),
                                        }));
                                    }}
                                />
                                <div style={{ display:'flex', gap:8, marginTop:10, justifyContent:'flex-end' }}>
                                    <button className="btn ghost sm" onClick={testarPanorama} disabled={!vozAtiva}>Ouvir agora</button>
                                    <button className="btn sm" onClick={salvarPanorama}>Salvar panorama</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    );
}
